import React from "react";
import "./style.css";

import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Breadcrumb as Crumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";

const Breadcrumb = ({ paths }) => {
  return (
    paths && paths.length && (
      <Crumb className="breadcrumb">
        {paths.map((path, idx) => (
          <BreadcrumbItem key={idx} isCurrentPage={path.isCurrentPage} >
            <BreadcrumbLink onClick={path.cb} as={Link} to={path.link} className={`${path.isCurrentPage ? "no-text-decoration" : ""} ${(path.link || path.cb) ? "link-text" : ""}`}>
              {path.name}
            </BreadcrumbLink>
          </BreadcrumbItem>
        ))}
      </Crumb>
    )
  );
};

Breadcrumb.propTypes = {
  paths: PropTypes.arrayOf(PropTypes.shape({
    idx: PropTypes.number,
    name: PropTypes.string,
    link: PropTypes.string,
    isCurrentPage: PropTypes.bool,
  })),
};

export default Breadcrumb;
